import {IN_PROGRESS_PROJECT} from '@/constants/projectStatuses'
import * as types from '@/constants/mutationTypes'

const state = {
  currentTab: IN_PROGRESS_PROJECT.id
}
const getters = {
  currentTab: state => state.currentTab
}
const actions = {
  setCurrentTab ({commit}, data) {
    commit(types.SET_CURRENT_TAB, {data})
  }
}
const mutations = {
  [types.SET_CURRENT_TAB] (state, {data}) {
    state.currentTab = data
  }}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/ActiveTabs/modules/store.js